export const isAnonymousCartEligibleDomain = (
  isPremiumDomain: boolean,
): boolean => !isPremiumDomain;
